import { Button, Checkbox, Label } from '@quadminds/mindkit';
import { useTranslation } from 'react-i18next';
import { Terms } from './Terms';

interface FeatureSliderProps {
    readonly onHandleTermsChange?: () => void;
    readonly handleNextStepTerms?: () => void;
    readonly setPrivacyPolicyAccepted?: () => void;
    readonly termsAccepted: boolean;
    readonly privacyPolicyAccepted: boolean;
    readonly buttonText: string;
}

export const TermsSlide = ({
    onHandleTermsChange,
    termsAccepted,
    handleNextStepTerms,
    privacyPolicyAccepted,
    setPrivacyPolicyAccepted,
    buttonText,
}: FeatureSliderProps) => {
    const { t } = useTranslation();

    return (
        <div className="flex flex-col space-y-4 p-8">
            <div className="flex flex-col items-start">
                <h2 className="text-2xl font-poppins font-semibold text-foreground">{t('onboarding.terms.title')}</h2>
                <p className="text-muted-foreground">{t('onboarding.terms.subtitle')}</p>
            </div>
            <hr />
            <div className="max-h-80 overflow-y-auto bg-background/50 scrollbar-thin scrollbar-thumb-gray-qm-100 dark:scrollbar-thumb-gray-qm-900 scrollbar-track-transparent">
                <Terms />
            </div>
            <div>
                <div className="flex items-center space-x-2">
                    <Checkbox
                        name="termsAccepted"
                        checked={termsAccepted}
                        onCheckedChange={() => onHandleTermsChange && onHandleTermsChange()}
                    />
                    <Label>{t('onboarding.terms.accept')}</Label>
                </div>
                <div className="flex items-center space-x-2 mt-5">
                    <Checkbox
                        name="termsAccepted"
                        checked={privacyPolicyAccepted}
                        onCheckedChange={() => setPrivacyPolicyAccepted && setPrivacyPolicyAccepted()}
                    />
                    <Label>
                        {t('onboarding.terms.iaccept')}{' '}
                        <a
                            href="https://www.quadminds.com/politica-de-privacidad-mindy"
                            className="underline"
                            target="_blank"
                            rel="noopener noreferrer"
                            aria-label={t('onboarding.terms.privPolitics')}
                        >
                            {t('onboarding.terms.privPolitics')}
                        </a>
                    </Label>
                </div>
            </div>
            <hr />
            <div className="flex justify-end">
                <Button onClick={handleNextStepTerms} disabled={!termsAccepted || !privacyPolicyAccepted}>
                    {buttonText}
                </Button>
            </div>
        </div>
    );
};
